import MEMBER_STATUS from "./memberStatus";

const PROFILE_STATUS_MAPPINGS = {
  [MEMBER_STATUS.reviewing]: [MEMBER_STATUS.assessing],
  [MEMBER_STATUS.active]: [MEMBER_STATUS.assessing, MEMBER_STATUS.reviewing],
  [MEMBER_STATUS.rejected]: [MEMBER_STATUS.assessing, MEMBER_STATUS.reviewing],
};

export default PROFILE_STATUS_MAPPINGS;
